import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-1226ad12");

var _hoisted_1 = {
  class: "li_wrapper"
};
var _hoisted_2 = {
  class: "li_container"
};
var _hoisted_3 = {
  class: "li_info--wrapper"
};
var _hoisted_4 = {
  class: "invitation-wrapper"
};
var _hoisted_5 = {
  class: "desc-wrapper"
};
var _hoisted_6 = {
  class: "li_desc"
};
var _hoisted_7 = {
  class: "action-wrapper"
};
var _hoisted_8 = {
  class: "li_title"
};

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 收起 ");

var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "img--wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/expand.png!w240",
  alt: ""
})], -1);

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 展开 ");

var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "img--wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn-fs.touchev.com/d/file/special/2023/spring-activity-2/collapse.png!w240",
  alt: ""
})], -1);

var _hoisted_14 = [_hoisted_12, _hoisted_13];
var _hoisted_15 = {
  key: 0,
  class: "li_rule"
};
var _hoisted_16 = {
  class: "rule-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_image = _resolveComponent("van-image");

  var _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "img--wrapper",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onClickList && $options.onClickList.apply($options, arguments);
    })
  }, [_createVNode(_component_van_image, {
    "lazy-load": "",
    width: "100",
    height: "100",
    fit: "cover",
    src: 'https://cdn-fs.touchev.com' + $props.item.coverImgUrl + '!w240',
    alt: ""
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString($props.item.title), 1)]), _createVNode(_component_van_button, {
    round: "",
    size: "small",
    type: "primary",
    color: "#FE5340",
    onClick: $options.onClickList
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString($options.statusText), 1)];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, [$options.integral ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.onClickList($props.item);
    })
  }, "送：" + _toDisplayString($options.integral || 0) + "积分", 1)) : _createCommentVNode("", true)]), $options.rule ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.expand ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "expand-wrapper",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $data.expand = !$data.expand;
    })
  }, _hoisted_11)) : _createCommentVNode("", true), !$data.expand ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "expand-wrapper",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.expand = !$data.expand;
    })
  }, _hoisted_14)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])])]), $options.rule && $data.expand ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString($options.rule), 1)])])) : _createCommentVNode("", true)]);
}